import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=768b02b5&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=js&"
export * from "./ProductCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=768b02b5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b02b5",
  null
  
)

export default component.exports